import { Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { HomeComponent } from './modules/home/home.component';

export const appRoutes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: '',
    loadChildren: () => import('./modules/parts/parts.module').then(m => m.PartsModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/claims/claims.module').then(m => m.ClaimsModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/document-management/document-management.module').then(m => m.DocManagementModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/issues/issues.module').then(m => m.IssuesModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/kpi-scorecards/kpi-scorecards.module').then(m => m.KpiScorecardsModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/supplyon/supplyon.module').then(m => m.SupplyOnModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/poc/poc.module').then(m => m.PocModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/common/common.module').then(m => m.CommonModuleNg),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
